import React, { createContext, useState } from 'react';
import { DocumentFieldItem, IDkvContext, IPicture } from '../models';

interface IDkvProviderProps {
	children: React.ReactNode;
}

export const DkvContext = createContext<IDkvContext>({
	inputFields: [],
	vehicleDataFilled: false,
	vehicleRegistration: undefined,
	updateVehicleRegistration: () => {},
	updateInputFields: () => {},
	updateVehicleDataFilled: () => {},
	resetDkv: () => {},
});

DkvContext.displayName = 'DkvContext';

export const DkvProvider = ({ children }: IDkvProviderProps) => {
	const [vehicleRegistration, setVehicleRegistration] = useState<IPicture | undefined>(undefined);
	const [vehicleDataFilled, setVehicleFilled] = useState<boolean>(false);
	const [inputFields, setInputFields] = useState<DocumentFieldItem[]>([]);

	const updateInputFields = (fields: DocumentFieldItem[]) => {
		setInputFields(fields);
	};

	const updateVehicleRegistration = (image: IPicture | undefined) => {
		setVehicleRegistration(image);
	};

	const updateVehicleDataFilled = (filled: boolean) => {
		setVehicleFilled(filled);
	};

	const resetDkv = () => {
		setVehicleFilled(false);
		setVehicleRegistration(undefined);
		setInputFields([]);
	};

	return (
		<DkvContext.Provider
			value={{
				inputFields,
				updateInputFields,
				vehicleRegistration,
				updateVehicleRegistration,
				vehicleDataFilled,
				updateVehicleDataFilled,
				resetDkv,
			}}>
			{children}
		</DkvContext.Provider>
	);
};
